<template>
  <div class="container">
    <my-nav-ui :idx="3"></my-nav-ui>
    <div class="bottom">
      <div class="left">
        <div class="content">
          <div class="row1">
            <!--   v-if="CurData.VideoPath.lastIndexOf('mp4')>0" -->
            <video
              id="video"
              width="500px"
              height="300px"
              style="width: 100%;height: 100%"
              autoplay="autoplay"
              controls="controls"
            >
              <source type="mp3/mp4" v-if="mp4source" :src="mp4source" />
            </video>
            <!--audio
              v-if="CurData.VideoPath.lastIndexOf('Mp3')>0"
              id="video"
              autoplay="autoplay"
              :src="mp4source"
              controls="controls"
            ></audio-->
          </div>
          <div class="row2">{{ remark }}</div>
        </div>
      </div>
      <div class="right">
        <div class="content">
          <el-scrollbar class="scroll">
            <div class="title">电梯成功救援历史查询</div>
            <div class="line">
              <span>地区</span>
              <span>时间</span>
              <span>地址</span>
            </div>
            <div
              class="line"
              v-for="item in data"
              :key="item.id"
              :class="getClass(item,curData)"
              @click="selectItem(item)"
            >
              <span>{{item.districtName}}</span>
              <span>{{item.rescueTime | time}}</span>
              <span>{{item.itemName + ' ' + item.buildCellNumber}}</span>
            </div>
          </el-scrollbar>
          <button @click="goBack" style="display: none">返回</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import GLOBAL from '@/api/global_variable'
export default {
  name: 'History',
  data() {
    return {
      loading: true,
      data: [],
      curData: null,
      mp4source: null,
      remark: ''
    }
  },
  mounted() {
    if (!GLOBAL.isLogin()) {
      this.$router.push({ path: '/login' })
    }
    this.loadData()
  },
  beforeDestroy() {},
  methods: {
    goBack: function(arg) {
      this.$router.push({ path: '/info' })
    },
    loadData: function(key) {
      var that = this
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId')
        },
        method: 'get',
        url:
          process.env.API_ROOT +
          '/Visual/fixing/rescue/history?page=1&limit=100'
      })
        .then(res => {
          that.data = res.data.result
          that.selectItem(res.data.result[0])
          that.curData = res.data.result[0]
        })
        .catch(err => {})
    },
    selectItem: function(item) {
      this.curData = item
      this.remark = item.remark
      if (this.curData) {
        var player = document.getElementById('video')
        player.src = item.rescueUrl
        player.load()
      }
    },
    getClass: function(item, curData) {
      if (item.id === curData.id) {
        return 'selected'
      }
    }
  }
}
</script>
<style lang="css" rel="stylesheet/scss"  scoped>
.el-loading-mask {
  background-color: transparent;
}
.container {
  width: 100%;
  height: calc(100% - 40px);
  background: #0b133f;
}
.bottom {
  padding-top: 10px;
  height: calc(100% - 110px);
  width: 99%;
  display: inline-flex;
}
.bottom .left {
  width: 70%;
  height: 100%;
}
.bottom .right {
  width: 30%;
  height: 100%;
}
.bottom .left .content {
  padding-top: 10px;
  height: calc(100% - 20px);
  width: calc(100% - 20px);
  background: #121d49;
  border-radius: 6px;
}
.bottom .left .row1 {
  width: calc(100% - 40px);
  height: calc(65% - 60px);
  margin: 20px;
  background: #000000;
  border-radius: 6px;
}
.bottom .left .row2 {
  height: calc(35% - 40px);
  width: calc(100% - 40px);
  font-size: 20px;
  color: #6c89aa;
  margin: 20px;
  text-align: left;
  line-height: 30px;
}
.right .content {
  margin: 0px 10px 10px 10px;
  height: calc(100% - 10px);
  width: calc(100% - 20px);
  background: #121d49;
  border-radius: 6px;
}
.right .content .scroll {
  height: calc(100% - 20px);
  width: 100%;
  overflow: hidden;
}
.right .content .line {
  width: 100%;
  height: 32px;
  display: inline-flex;
  cursor: pointer;
}
.right .content .title {
  width: 100%;
  height: 42px;
  line-height: 42px;
  text-align: center;
  color: #6c89aa;
  font-size: 24px;
}
.right .content .selected {
  background: #ecf5ff !important;
}
.right .content .line span {
  color: #6c89aa;
  display: block;
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  white-space: nowrap;
  overflow: hidden;
}
.right .content .line span:nth-child(1) {
  width: 20% !important;
}
.right .content .line span:nth-child(2) {
  width: 30% !important;
}
.right .content .line span:nth-child(3) {
  width: 50% !important;
  text-align: left;
}
button {
  padding: 6px 20px 6px 20px;
  border-radius: 8px;
  border: 1px solid #1f4687;
  background: #172351;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/EchartsView3-1.vue